<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="param.from_date"/> ~ <CustomDatePicker v-model="param.to_date"/></span>
				<item-class-select-multi-s v-model="param.classes" />
				<sales-group v-model="param.sales_group" ref="salesGroupCode" />
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<!--				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>-->
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
					</colgroup>
					<thead>
						<tr>
							<th>Item {{ headers.class }}</th>
							<th>Color Code</th>
							<th>Partner Code</th>
							<th>Partner Name</th>
							<th>Phone</th>
							<th>Email</th>
							<th>Address</th>
							<th>City</th>
							<th>State</th>
							<th>Zip Code</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="itemClass in data.list">
							<template v-for="(itemMaster, itemIndex) in itemClass.list">
								<template v-for="(customer, customerIndex) in itemMaster.customer">
									<tr :key="itemClass.code + itemMaster.item_id + customer.code">
										<td>
											<span v-if="!itemIndex && !customerIndex">
												{{ itemClass.itemClass.code }}
											</span>
										</td>
										<td>
											<span v-if="!customerIndex">
												{{ itemMaster.item.color_code }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.code }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.name }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.telephone }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.email }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.address_detail }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.address_city }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.address_state }}
											</span>
										</td>
										<td>
											<span>
												{{ customer.address_zipcode }}
											</span>
										</td>
									</tr>
								</template>
							</template>
						</template>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
				<!--				<li>-->
				<!--					<a href="javascript:void(0);" v-on:click="print">Print</a>-->
				<!--				</li>-->
			</ul>
		</div>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';
import SalesGroup from '@/components/common/SalesGroup';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import { today } from '@/utils/date';
import { apiNoCertainItemsCustomer } from '@/api/report/report';
import { apiGetReportTemplate, exportFile, objectToUrlParam, Report, reportMrtUrl } from '@/api/util';

export default {
	props: ['headers'],
	name: 'NoCertainItemsCustomer',
	data: function() {
		return {
			param: {
				from_date: today(),
				to_date: today(),
				classes: '',
				sales_group: '',
			},
			data: '',
		};
	},
	methods: {
		async search() {
			if (!this.param.classes) {
				this.$toast.error(`Item ${this.headers.class} is empty`);
				return false;
			}
			if (!this.param.sales_group) {
				this.$toast.error('Sales Group is empty');
				return false;
			}
			const { data } = await apiNoCertainItemsCustomer(objectToUrlParam(this.param));
			this.data = data;
		},
		async excel() {
			const reportTemplate = await apiGetReportTemplate('CustomerListWithoutCertainItems', reportMrtUrl('CustomerListWithoutCertainItems'));
			const report = new Report(reportTemplate, this.data, 'CustomerListWithoutCertainItems');
			exportFile(report, 'excel', true);
		},
	},
	components: {
		CustomDatePicker,
		SalesGroup,
		ItemClassSelectMultiS,
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_customer_list_with_no_certain_items');
		this.$store.commit('setSubTitle', 'Report -> Customer List Without Certain Items');
	},
};
</script>

<style scoped></style>
